/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { IAwardCategoryData } from "Interfaces/AwardCategories/IAwardCategoriesResult";

// Define the initial state for the award categories slice
const initialState = {
  // Set the list of award categories
  awardCategories: [],
  // Set the selected award category
  selectedAwardCategory: {} as IAwardCategoryData,
  // Set the error message when fetching award categories
  fetchAwardCategoriesError: "",
  // Set the error message when updating award categories
  updateACErrorMessage: "",
  // Set true if award category is updated from side panel
  isAwardCategoryUpdated: false,
};

// Create the award categories slice to hold state, reducers and selectors for award categories
export const awardCategoriesSlice = createSlice({
  name: "awardCategories",
  initialState,
  reducers: {
    selectAwardCategory: (state, action: PayloadAction<IAwardCategoryData>) => {
      state.selectedAwardCategory = action.payload;
    },
    updateACErrorMessage: (state, action: PayloadAction<string>) => {
      state.updateACErrorMessage = action.payload;
    },
    setIsAwardCategoryUpdated: (state, action: PayloadAction<boolean>) => {
      state.isAwardCategoryUpdated = action.payload;
    },
  },
  selectors: {
    getSelectedAwardCategory: (state) => state.selectedAwardCategory, // Get the selected award category
    getUpdateACErrorMessage: (state) => state.updateACErrorMessage, // Get the error message when updating award categories
    getIsAwardCategoryUpdated: (state) => state.isAwardCategoryUpdated, // Get the status of award category update
  },
});

export const { selectAwardCategory, updateACErrorMessage, setIsAwardCategoryUpdated } = awardCategoriesSlice.actions;
export const { getSelectedAwardCategory, getUpdateACErrorMessage, getIsAwardCategoryUpdated } =
  awardCategoriesSlice.selectors;
export default awardCategoriesSlice.reducer;
